<template>
  <Container>
    <PageHeader :items="items" />

    <div class="row">
      <div class="col-lg-6">
        <div class="row">
          <div class="col-12">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div class="row">
                  <div class="col-7">
                    <div class="text-primary p-3"><h5 class="text-primary">Welcome Back !</h5></div>
                  </div>

                  <div class="col-5 align-self-end">
                    <img src="/img/profile-img.ba4e037e.png" alt="" class="img-fluid" />
                  </div>
                </div>
              </div>

              <div class="card-body pt-0">
                <div class="row">
                  <div class="col-12">
                    <div class="avatar-md profile-user-wid mb-4">
                      <img src="/img/avatar-1.67e2b9d7.jpg" alt="" class="img-thumbnail rounded-circle" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-8">
                    <h5 class="font-size-15 text-truncate">
                      {{ profile.attributes.first_name }} {{ profile.attributes.last_name }}
                    </h5>
                    <p class="text-muted mb-0 text-truncate">{{ profile.attributes.email }}</p>
                    <p class="text-muted mb-0 text-truncate">{{ profile.attributes.address }}</p>
                    <p class="text-muted mb-0 text-truncate">{{ profile.attributes.phone_number }}</p>
                    <p class="text-muted mb-0">
                      Booking Engine:
                      <a :href="`https://${profile.attributes.organization.subdomain}.rentalbeyond.com`">
                        https://{{ profile.attributes.organization.subdomain }}.rentalbeyond.com
                      </a>
                    </p>
                  </div>

                  <div class="col-4 text-right">
                    <b-button @click="editProfile()" v-b-modal.profile-modal variant="outline-secondary">
                      <i class="fa fa-pencil-alt"></i> Edit
                    </b-button>
                  </div>

                  <b-modal size="lg" id="profile-modal" title="Edit Profile" title-class="font-18">
                    <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                      <b-form id="profile-form" @submit.prevent="handleSubmit(onUpdate)">
                        <b-row>
                          <b-col sm="6">
                            <b-form-group label="First name" label-for="first_name">
                              <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                                <b-form-input
                                  id="first_name"
                                  v-model="employee.first_name"
                                  placeholder="Enter first name"
                                ></b-form-input>

                                <small class="text-danger">{{ errors[0] }}</small>
                              </ValidationProvider>
                            </b-form-group>
                          </b-col>

                          <b-col sm="6">
                            <b-form-group label="Last Name" label-for="last_name">
                              <ValidationProvider rules="required|min:2" v-slot="{ errors }">
                                <b-form-input
                                  id="last_name"
                                  v-model="employee.last_name"
                                  placeholder="Enter last Name"
                                ></b-form-input>

                                <small class="text-danger">{{ errors[0] }}</small>
                              </ValidationProvider>
                            </b-form-group>
                          </b-col>
                        </b-row>

                        <b-form-group label="Phone number" label-for="phone">
                          <ValidationProvider rules="required|min:7" v-slot="{ errors }">
                            <b-form-input
                              id="phone"
                              v-model="employee.phone_number"
                              placeholder="Enter phone number"
                            ></b-form-input>

                            <small class="text-danger">{{ errors[0] }}</small>
                          </ValidationProvider>
                        </b-form-group>
                      </b-form>
                    </ValidationObserver>

                    <template v-slot:modal-footer>
                      <b-button variant="secondary" @click="$bvModal.hide('profile-modal')">Close</b-button>
                      <b-button form="profile-form" type="submit" variant="primary">Save</b-button>
                    </template>
                  </b-modal>

                  <div class="col-lg-12 col-md-6 col-xs-12 d-none">
                    <div class="pt-4">
                      <div class="row">
                        <div class="col-4">
                          <h5 class="font-size-15">12</h5>
                          <p class="text-muted mb-0">Bookings</p>
                        </div>

                        <div class="col-4">
                          <h5 class="font-size-15">5</h5>
                          <p class="text-muted mb-0">History</p>
                        </div>

                        <div class="col-4">
                          <h5 class="font-size-15">8</h5>
                          <p class="text-muted mb-0">Favorites</p>
                        </div>
                      </div>

                      <div class="mt-4">
                        <a href="" class="btn btn-primary btn-sm">
                          View Profile <i class="mdi mdi-arrow-right ml-1"></i
                        ></a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import Container from "../views/layouts/main";
import PageHeader from "@/components/page-header";
import { mapActions } from "vuex";
import { getProfile, updateProfile } from "@/store/api";

export default {
  components: {
    Container,
    PageHeader,
  },

  data() {
    return {
      profile: null,
      employee: {
        first_name: "",
        last_name: "",
        phone_number: "",
      },
      items: [
        {
          text: "Home",
          to: "/",
        },
        {
          text: "Profile",
          active: true,
        },
      ],
    };
  },

  created() {
    getProfile().then((response) => (this.profile = response));
  },

  methods: {
    ...mapActions(["login"]),

    editProfile() {
      this.employee.first_name = this.profile.attributes.first_name;
      this.employee.last_name = this.profile.attributes.last_name;
      this.employee.phone_number = this.profile.attributes.phone_number;
    },

    onUpdate() {
      updateProfile({ employee: this.employee }).then((response) => {
        this.$bvModal.hide("profile-modal");
        this.profile = response;
      });
    },
  },
};
</script>
